import { render, staticRenderFns } from "./AgentBrowser.vue?vue&type=template&id=671b4e9e&scoped=true"
import script from "./AgentBrowser.vue?vue&type=script&lang=ts"
export * from "./AgentBrowser.vue?vue&type=script&lang=ts"
import style0 from "./AgentBrowser.vue?vue&type=style&index=0&id=671b4e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b4e9e",
  null
  
)

export default component.exports